import React from 'react';
import styled from '@emotion/styled';
import { InternalLinkButton, breakpoints, normalize } from 'gatsby-theme-apollo';
import { Flex } from './flex';

const StyledSectionHeader = styled.div({
  textAlign: 'center',
  fontWeight: 'bold',
  justifyContent: `center`,
  alignItems: `center`,
  position: `relative`,
  display: `flex`,
  margin: `10px 0px`
});

const StyledSection = styled.section(props => ({
  backgroundColor: props.solidBackground
    ? props.theme.backgroundDarkSemiTransparent
    : `transparent`,
  padding: '5px 0px',
  borderRadius: '5px',
  boxSizing: `border-box`
}));

const SectionHeaderTitle = styled.h2(props => ({
  textAlign: `center`,
  color: props.color ? props.theme.background : `inherit`,
  display: `inline`,
  position: `relative`,
  textTransform: `uppercase`,
  ':after': {
    backgroundColor: props.theme.primaryAccent || props.theme.primary
  }
}));

const SectionHeaderTitleH1 = SectionHeaderTitle.withComponent('h1');

const SectionHeaderTitleText = styled.div(props => ({
  position: `relative`,
  padding: `0px 10px`,
  fontFamily: props.theme.fontFamily,
  textShadow: props.theme.textShadow
}));

const SectionHeaderLink = styled.div({
  position: `absolute`,
  right: `10px`,
  [breakpoints.lg]: {
    position: `relative`,
    marginLeft: `20px`
  }
});

const SectionHeader = ({ text, linkTarget, linkText, color, h1 }) => {
  return (
    <StyledSectionHeader>
      {!h1 ? (
        <SectionHeaderTitle color={color}>
          <SectionHeaderTitleText>{text}</SectionHeaderTitleText>
        </SectionHeaderTitle>
      ) : (
        <SectionHeaderTitleH1 color={color}>
          <SectionHeaderTitleText>{text}</SectionHeaderTitleText>
        </SectionHeaderTitleH1>
      )}
      {linkTarget && (
        <SectionHeaderLink>
          <InternalLinkButton primary to={linkTarget}>
            {linkText || 'View All'}
          </InternalLinkButton>
        </SectionHeaderLink>
      )}
    </StyledSectionHeader>
  );
};

const SectionContent = styled.div`
  padding: ${props => (props.flush ? `0px` : `5px`)};
`;

const PageAnchor = styled.a({
  position: `absolute`,
  top: `-40px`
});

const Section = ({
  children,
  title,
  linkTarget,
  linkText,
  textColor,
  fullWidth,
  solidBackground,
  flushContent,
  hideMobile,
  h1
}) => {
  return (
    <Flex
      disappearXL={hideMobile}
      style={{
        width: `100%`,
        maxWidth: fullWidth ? `100%` : `1024px`,
        margin: `0px auto`,
        position: `relative`
      }}
    >
      <PageAnchor name={normalize.hyphenateAndLowerCase(title)} />
      <StyledSection style={{ width: '100%', color: textColor }} solidBackground={solidBackground}>
        {title && (
          <SectionHeader
            text={title}
            linkTarget={linkTarget}
            color={textColor}
            linkText={linkText}
            h1={h1}
          />
        )}
        <SectionContent flush={flushContent}>{children}</SectionContent>
      </StyledSection>
    </Flex>
  );
};

export default Section;
